import React, { useState } from 'react';
import { Search, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const suggestions = ['Steak', 'Chicken', 'Kebab', 'Burger', 'Fish & Chips', 'Rolex', 'Pizza', 'Soda', 'Juice'];

const SmartSearch = () => {
  const [query, setQuery] = useState('');
  const [focused, setFocused] = useState(false);
  const navigate = useNavigate();

  const filtered = query.length > 0
    ? suggestions.filter(s => s.toLowerCase().includes(query.toLowerCase()))
    : suggestions.slice(0, 5);

  const handleSearch = (term) => {
    navigate(`/menu?search=${encodeURIComponent(term)}`);
    setQuery('');
    setFocused(false);
  };

  return (
    <div style={{ position: 'relative', width: '100%', maxWidth: '300px' }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: '8px',
        background: 'rgba(255,255,255,0.1)', borderRadius: '100px',
        padding: '8px 16px', border: '1px solid rgba(255,255,255,0.15)',
        transition: 'all 0.3s ease'
      }}>
        <Search size={16} color="rgba(255,255,255,0.5)" />
        <input
          type="text"
          placeholder="Search menu..."
          value={query}
          onChange={e => setQuery(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setTimeout(() => setFocused(false), 200)}
          style={{
            background: 'none', border: 'none', outline: 'none',
            color: '#fff', fontSize: '0.85rem', width: '100%',
            fontFamily: 'Poppins, sans-serif'
          }}
          aria-label="Search menu items"
        />
        {query && (
          <button onClick={() => setQuery('')} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
            <X size={14} color="rgba(255,255,255,0.5)" />
          </button>
        )}
      </div>

      {focused && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0,
          background: '#fff', borderRadius: '12px', marginTop: '8px',
          boxShadow: '0 8px 30px rgba(0,0,0,0.15)', padding: '8px 0',
          zIndex: 1000
        }}>
          {!query && (
            <div style={{ padding: '8px 16px', fontSize: '0.7rem', color: '#999', textTransform: 'uppercase', letterSpacing: 1, fontWeight: 600 }}>
              Trending Searches
            </div>
          )}
          {filtered.map((s, i) => (
            <button key={i} onClick={() => handleSearch(s)} style={{
              display: 'block', width: '100%', padding: '10px 16px',
              background: 'none', border: 'none', textAlign: 'left',
              cursor: 'pointer', fontSize: '0.9rem', color: '#2C2C2C',
              transition: 'background 0.2s'
            }}
              onMouseEnter={e => e.target.style.background = '#faf8f5'}
              onMouseLeave={e => e.target.style.background = 'none'}
            >
              <Search size={12} style={{ marginRight: 8, opacity: 0.4 }} />
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SmartSearch;
